const NoResults = () => {
  return (
    <div className="flex flex-col justify-center items-center gap-[32px] py-[130px]">
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_7179_7735)">
          <path
            d="M28 0C12.5608 0 0 12.5608 0 28C0 43.4392 12.5608 56 28 56C43.4392 56 56 43.4392 56 28C56 12.5608 43.4392 0 28 0ZM28 52.9729C21.1405 52.9729 14.9187 50.1926 10.4008 45.7004C8.59668 43.9065 7.06518 41.839 5.8727 39.5668C4.05665 36.1067 3.02707 32.1715 3.02707 28C3.02707 14.2299 14.2299 3.02707 28 3.02707C34.5315 3.02707 40.4842 5.54862 44.9389 9.66808C47.2486 11.8037 49.1558 14.3684 50.531 17.235C52.0956 20.4965 52.9729 24.1477 52.9729 28C52.9729 41.7701 41.7701 52.9729 28 52.9729Z"
            fill="#0052B4"
          />
          <path
            d="M30.9579 35.4936C34.279 36.1881 37.2622 38.0553 39.358 40.7511L41.7477 38.8932C39.2122 35.6315 35.6001 33.3718 31.5775 32.5305C25.1081 31.1785 18.3065 33.6755 14.25 38.8932L16.6401 40.7511C19.9918 36.4396 25.6121 34.3755 30.9579 35.4936Z"
            fill="#0052B4"
          />
          <path
            d="M18.6677 24.7836C20.3395 24.7836 21.6948 23.4284 21.6948 21.7566C21.6948 20.0848 20.3395 18.7295 18.6677 18.7295C16.9959 18.7295 15.6406 20.0848 15.6406 21.7566C15.6406 23.4284 16.9959 24.7836 18.6677 24.7836Z"
            fill="#0052B4"
          />
          <path
            d="M37.3982 24.7836C39.07 24.7836 40.4252 23.4284 40.4252 21.7566C40.4252 20.0848 39.07 18.7295 37.3982 18.7295C35.7264 18.7295 34.3711 20.0848 34.3711 21.7566C34.3711 23.4284 35.7264 24.7836 37.3982 24.7836Z"
            fill="#0052B4"
          />
        </g>
        <defs>
          <clipPath id="clip0_7179_7735">
            <rect width="56" height="56" fill="white" />
          </clipPath>
        </defs>
      </svg>

      <p className="text-[34px] font-[300] leading-[36px]">No Results Found</p>
    </div>
  );
};

export default NoResults;
